import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const fetchCDBalanceList = async (urlParams) => {
  try {
    let url = ATP_API_URL.GET_ALL_CDBALANCE;

    const response = await apiClient.post(url, urlParams);

    if (response?.data?.status) {
      return response.data;
    }

    return response?.data?.message || "Something went wrong, Please, try again";
  } catch (error) {}
};

export const fetchPremiumCdBalanceList = async (urlParams) => {
  try {
    let url = ATP_API_URL.GET_PREMIUM_CD_BALANCE;

    const response = await apiClient.post(url, urlParams);

    if (response?.data?.status) {
      return response.data;
    }

    return response?.data?.message || "Something went wrong, Please, try again";
  } catch (error) {}
};
